import { CircularProgress, IconButton, IconButtonProps, SxProps, Theme } from '@mui/material';
import { FunctionComponent, PropsWithChildren } from 'react';
import { Wrapper } from './Wrapper';

interface ProgressIconButtonProps extends IconButtonProps {
  loading: boolean;
  spinnerSize?: number;
  sxProps?: SxProps<Theme>;
}

export const ProgressIconButton: FunctionComponent<PropsWithChildren<ProgressIconButtonProps>> = ({
  loading,
  disabled,
  spinnerSize = 24,
  sxProps = {},
  ...rest
}) => (
  <Wrapper sxProps={sxProps}>
    {loading ? (
      <CircularProgress size={spinnerSize} className="spinner" />
    ) : (
      <IconButton disabled={loading || disabled} {...rest} size="large" />
    )}
  </Wrapper>
);
